import $ from 'jquery';
import 'jquery-mask-plugin';
import onDocumentReady from '../util/onDocumentReady';

$.jMaskGlobals.translation = {
    '0': {pattern: /\d/},
};

onDocumentReady(() => {
    $('.control-input--date').mask('00.00.0000');
    $('.control-input--phone').mask("+91 0000-000000");
});
